import React from "react";
import ReactPlayer from "react-player";

function VideoSection() {
  return (
    <div style={{ maxWidth: '800px', margin: '40px auto', padding: '0 20px' }}>
      <ReactPlayer 
        url="https://youtu.be/aS4CGwJguKg" 
        controls
        width="100%"
      />
    </div>
  );
}

export default VideoSection; 